// extracted by mini-css-extract-plugin
module.exports = {"logOutBtn":"ProfileDetail_logOutBtn__3LNsF","loginButton":"ProfileDetail_loginButton__3Y1kY"};